import { render } from "./KRSortOrderActivity.vue?vue&type=template&id=ed1503b6"
import script from "./KRSortOrderActivity.vue?vue&type=script&lang=js"
export * from "./KRSortOrderActivity.vue?vue&type=script&lang=js"
script.render = render

export default script